<div [class.show]="control?.invalid && control?.touched" [ngClass]="containerClassName">
    <ng-container *ngIf="control?.errors">
        <span class="error-text">
            <i class="fa fa-exclamation-triangle"></i>
          <span [innerHTML]="message(control?.errors) | translate: getInterpolationDataByError(control?.errors)"></span>
        </span>
    </ng-container>
</div>
